var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "player-props", class: [{ "one-event": _vm.oneEvent }] },
    [
      _c(
        "div",
        {
          staticClass: "props-container props",
          class: [{ "team-logo": _vm.displayLogos }]
        },
        [
          _c(
            "div",
            {
              staticClass: "props-holder",
              on: {
                click: function($event) {
                  $event.stopPropagation()
                  return _vm.headerClick(_vm.event)
                }
              }
            },
            [
              _c("div", { staticClass: "title-wrapper" }, [
                _c("div", { staticClass: "home item" }, [
                  _vm.displayLogos
                    ? _c("div", { staticClass: "item logo home" }, [
                        _c("img", { attrs: { src: _vm.logosSource } })
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.isAmerican && _vm.event.participantname_home
                    ? _c("div", { staticClass: "item player-props-home" }, [
                        _vm._v(_vm._s(_vm.event.participantname_home))
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isAmerican && _vm.event.participantname_away
                    ? _c("div", { staticClass: "item player-props-home" }, [
                        _vm._v(_vm._s(_vm.event.participantname_away))
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.event.participantname_home &&
                  !_vm.event.participantname_away &&
                  _vm.event.eventname
                    ? _c("div", { staticClass: "item player-props-home" }, [
                        _vm._v(_vm._s(_vm.event.eventname))
                      ])
                    : _vm._e()
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "item time" }, [
                  _vm.event.tsstart && _vm.isDateToday(_vm.event.tsstart)
                    ? _c("span", [
                        _vm._v(
                          _vm._s(_vm.$t("PlayerProps.Event.Today")) +
                            " " +
                            _vm._s(
                              _vm._f("moment")(
                                _vm.event.tsstart,
                                _vm.dateFormats.longTime
                              )
                            )
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.event.tsstart && _vm.isDateTomorrow(_vm.event.tsstart)
                    ? _c("span", [
                        _vm._v(
                          _vm._s(_vm.$t("PlayerProps.Event.Tomorrow")) +
                            " " +
                            _vm._s(
                              _vm._f("moment")(
                                _vm.event.tsstart,
                                _vm.dateFormats.longTime
                              )
                            )
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.event.tsstart &&
                  !_vm.isDateToday(_vm.event.tsstart) &&
                  !_vm.isDateTomorrow(_vm.event.tsstart)
                    ? _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm._f("moment")(
                              _vm.event.tsstart,
                              _vm.dateFormats.dayAndMonthAndDateUS
                            )
                          ) + " "
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.timeZone
                    ? _c("span", [_vm._v("[" + _vm._s(_vm.timeZone) + "]")])
                    : _vm._e()
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "away item" }, [
                  _vm.displayLogos
                    ? _c("div", { staticClass: "item logo away" }, [
                        _c("img", { attrs: { src: _vm.logosSource } })
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.isAmerican && _vm.event.participantname_away
                    ? _c("div", { staticClass: "item player-props-away" }, [
                        _vm._v(_vm._s(_vm.event.participantname_away))
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isAmerican && _vm.event.participantname_home
                    ? _c("div", { staticClass: "item player-props-away" }, [
                        _vm._v(_vm._s(_vm.event.participantname_home))
                      ])
                    : _vm._e()
                ])
              ])
            ]
          ),
          _vm._v(" "),
          _vm.event.markets.length > 0
            ? _c(
                "div",
                {
                  staticClass: "content-wrapper",
                  on: {
                    click: function($event) {
                      return _vm.viewMore(_vm.event)
                    }
                  }
                },
                _vm._l(_vm.event.markets, function(market, index) {
                  return _c(
                    "div",
                    { key: market.idfomarket, staticClass: "content" },
                    [
                      _c("markets", {
                        attrs: {
                          event: _vm.event,
                          markets: _vm.getMarketWithFirstSelection(market),
                          playerPropsWidget: true,
                          diplayOnPage: "live-single-event",
                          pricechangehighlight: true,
                          isLastMarket: index !== _vm.event.markets.length - 1
                        }
                      })
                    ],
                    1
                  )
                }),
                0
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.hasMoreThanThreeSelections(_vm.event)
            ? _c("div", { staticClass: "view-more-container" }, [
                _c("div", { staticClass: "view-more" }, [
                  _c("button", {
                    domProps: {
                      innerHTML: _vm._s(
                        _vm.$t("PlayerProps.Widget.ViewMoreThenThree")
                      )
                    },
                    on: {
                      click: function($event) {
                        return _vm.viewMore(_vm.event)
                      }
                    }
                  })
                ])
              ])
            : _vm._e()
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7fe839d6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7fe839d6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sports/bettingoffer/playerPropsWidget/PlayerPropsWidget.vue
// module id = null
// module chunks = 